import { render } from "./LeftTypeSelectorItem.vue?vue&type=template&id=3b607b89&scoped=true"
import script from "./LeftTypeSelectorItem.vue?vue&type=script&lang=js"
export * from "./LeftTypeSelectorItem.vue?vue&type=script&lang=js"

import "./LeftTypeSelectorItem.vue?vue&type=style&index=0&id=3b607b89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b607b89"]])

export default __exports__